import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { PutLeadTimeAdapter } from '../adapters/putLeadTimeAdapter';
import { DateUnitType } from '@/coreDomainsModule/date';

/**
 * リードタイムを更新するユースケース
 */
export class PutLeadTimeUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * リードタイムを更新する
   * @param aggregateBusinessId - 集計ID
   * @param leadTimeValue - リードタイムの値
   * @param leadTimeUnit - リードタイムの単位
   */
  public async Execute(
    aggregateBusinessId: string,
    leadTimeValue: number,
    leadTimeUnit: DateUnitType
  ): Promise<INetworkResult<void, Error>> {
    const request = PutLeadTimeAdapter.adapt(leadTimeValue, leadTimeUnit);
    try {
      const result = await this.repository.putLeadTime(aggregateBusinessId, request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
